import { render, staticRenderFns } from "./SkeletonCardTile.vue?vue&type=template&id=23b65b15&scoped=true"
import script from "./SkeletonCardTile.vue?vue&type=script&lang=js"
export * from "./SkeletonCardTile.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCardTile.vue?vue&type=style&index=0&id=23b65b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b65b15",
  null
  
)

export default component.exports